import axios, { AxiosResponse } from "axios";

import { Auth } from "./auth/Authentication";
import { verifyWebsiteStatus } from "./middlewares/verifyWebsiteStatus";

const auth = Auth.getInstance();

export const runMiddlewares = async (...functions: (() => void)[]) => {
    await Promise.all(
        functions.map(async (middleware) => {
            await middleware();
        })
    );
};

// TODO: Tipar corretamente
export const axiosHttpClient = async (data: {
    url: string;
    method: string;
    body?: any;
    headers?: any;
    params?: any;
}) => {
    let axiosResponse: AxiosResponse;

    await runMiddlewares(verifyWebsiteStatus);

    const isFormData = data.body instanceof FormData;

    try {
        axiosResponse = await axios.request({
            url: data.url,
            method: data.method,
            data: data.body,
            headers: {
                ...data.headers,
                ...(data.headers?.auth && {
                    Authorization: `Bearer ${auth.token}`,
                }),
                ...(data.headers?.refresh && {
                    "x-refresh-token": auth.refreshToken,
                }),
                ...(isFormData ? {} : { "Content-Type": "application/json" }),
            },
            params: data.params,
        });
    } catch (error: any) {
        axiosResponse = error.response;
    }
    return {
        statusCode: axiosResponse?.status,
        body: axiosResponse?.data,
    };
};
